import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/rootReducer';
import { Navigate } from 'react-router-dom';

type NonAuthedContainerProps = {
  children: ReactElement;
};

const NonAuthedContainer: FC<NonAuthedContainerProps> = ({
  children,
}: NonAuthedContainerProps) => {
  const auth = useSelector((state: RootState) => state.auth);
  if (auth.token.access) {
    return <Navigate to="/" replace />;
  } else {
    return children;
  }
};

export default NonAuthedContainer;
